import React from "react";
// import listData from "./listdata";
// import list from "./listData.json";
// import dummy from "./dummy.json";

const Liststringify = () => {
	// const mystringify = JSON.stringify(listData);
	// console.log('jgygyugui',list);

	// const myparse = JSON.parse(listData);
	// console.log(list[1]);

	/* fetch(dummy)
		.then((response) => console.log(response))
		.catch((error) => {
			console.error("Error fetching/parsing JSON:", error);
		}); */

	return <div>JIGAR</div>;
};

export default Liststringify;
